const footerCols = [
  {
    title: "阅读导航",
    links: [
      { label: "热门榜单", href: "#rank" },
      { label: "霸榜作品", href: "#top" },
      { label: "追更进度", href: "#updates" },
      { label: "周更作品", href: "#weekly" },
    ],
  },
  {
    title: "题材分类",
    links: [
      { label: "热血冒险", href: "#category" },
      { label: "古风武侠", href: "#category" },
      { label: "悬疑推理", href: "#category" },
      { label: "恋爱校园", href: "#category" },
    ],
  },
  {
    title: "帮助支持",
    links: [
      { label: "常见问题", href: "#faq" },
      { label: "关于我们", href: "#about" },
      { label: "联系我们", href: "#contact" },
      { label: "用户协议", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 text-foreground-800">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2" aria-label="番木瓜漫画">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-empathize-line text-xl"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-950">番木瓜漫画</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              人气连载一网打尽，追更进度条实时同步。热门榜单、霸榜作品、长期连载周更不断，不错过每一话更新。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-mail-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  aria-label="社交媒体"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerCols.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold uppercase tracking-wide text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-200/80 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 番木瓜漫画 fanmugua.readdy.site · 人气连载与追更进度均以站内实时数据为准
          </p>
          <div className="flex gap-5">
            <a href="#about" className="text-xs text-foreground-500 hover:text-primary-600">
              关于我们
            </a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-600">
              常见问题
            </a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-600">
              商务合作
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}